import { type ReactElement, useLayoutEffect } from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';

import { useAuth } from '@/hooks/use-auth';
import {
  normalizeAppReturnPath,
  POST_LOGIN_REDIRECT_STORAGE_KEY,
} from '@/lib/auth/post-login-redirect';
import { hasSupplierPortalAccess } from '@/lib/auth/role-access';
import { ROUTES } from '@/lib/constants/routes';

/**
 * Requires authentication and the supplier role.
 */
export function ProtectedRoute(): ReactElement {
  const { isAuthenticated, user } = useAuth();
  const location = useLocation();
  useLayoutEffect(() => {
    if (isAuthenticated) {
      return;
    }
    const returnPath = `${location.pathname}${location.search}`;
    if (returnPath !== ROUTES.LOGIN) {
      sessionStorage.setItem(POST_LOGIN_REDIRECT_STORAGE_KEY, normalizeAppReturnPath(returnPath));
    }
  }, [isAuthenticated, location.pathname, location.search]);
  if (!isAuthenticated) {
    return <Navigate to={ROUTES.LOGIN} replace />;
  }
  if (!hasSupplierPortalAccess(user?.roles)) {
    return <Navigate to={ROUTES.UNAUTHORIZED} replace />;
  }
  return <Outlet />;
}
